<template>
  <div class="evidencias-wrapper py-5">
    <div class="container">
      <h2 class="titulo text-center mb-4" style="font-family: ColgateReady-Regular;">
        Evidencias Registradas
      </h2>

      <!-- Buscador -->
      <div class="mb-4 d-flex justify-content-center">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control w-50"
          placeholder="Buscar por nombre del niño o niña..."
        />
      </div>

      <!-- Grid de tarjetas -->
      <div class="row g-4">
        <div
          class="col-md-6 col-lg-3 d-flex"
          v-for="(hijo, index) in paginatedHijos"
          :key="index"
        >
          <div class="w-100 h-100 d-flex">
            <HijoCard :hijo="hijo" class="flex-grow-1" />
          </div>
        </div>
      </div>

      <!-- Paginación -->
      <div
        v-if="totalPages > 1"
        class="custom-pagination mt-5 d-flex justify-content-center align-items-center gap-3" style="font-family: ColgateReady-Regular;"
      >
        <button
          class="btn btn-danger"
          :disabled="currentPage === 1"
          @click="changePage(currentPage - 1)"
        >
          Anterior
        </button>

        <div class="page-text">
          Página {{ currentPage }} de {{ totalPages }}
        </div>

        <button
          class="btn btn-danger"
          :disabled="currentPage === totalPages"
          @click="changePage(currentPage + 1)"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import HijoCard from '../components/HijoCard.vue'
import api from '../services/api'

const hijos = ref([])
const searchQuery = ref('')
const currentPage = ref(1)
const itemsPerPage = 12

// Filtra por nombre
const filteredHijos = computed(() => {
  if (!searchQuery.value) return hijos.value
  return hijos.value.filter(hijo =>
    hijo.nombre_hijo.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const totalPages = computed(() =>
  Math.ceil(filteredHijos.value.length / itemsPerPage)
)

const paginatedHijos = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage
  const end = start + itemsPerPage
  return filteredHijos.value.slice(start, end)
})

function changePage(page) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

// Reinicia a la página 1 cuando cambia el filtro
watch(searchQuery, () => {
  currentPage.value = 1
})

onMounted(async () => {
  try {
    const res = await api.get('/evidencias')
    hijos.value = res.data
  } catch (error) {
    console.error('Error cargando evidencias:', error)
  }
})
</script>

<style scoped>
.evidencias-wrapper {
  background: linear-gradient(135deg, #FADBDB, #EFBFBF, #CCB1D4);
  min-height: 100vh;
}

.titulo {
  font-weight: 700;
  font-size: 2rem;
  color: #4b1e57;
}

.custom-pagination .btn {
  padding: 0.5rem 1.2rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 0.5rem;
}

.custom-pagination .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.page-text {
  font-weight: 600;
  font-size: 1rem;
  color: #333;
}
</style>
